import styled from 'styled-components';

export const Wrapper = styled.div<{
  variant?:
    | 'contains_alcohol'
    | 'alcohol_free'
    | 'gluten_free'
    | 'lactose_free'
    | 'sugar_free'
    | 'vegan'
    | 'vegetarian'
    | (string & Record<never, never>);
}>`
  height: 20px;
  padding: 0 8px;
  background: var(--white);
  border: 1px solid #6da9db;
  border-radius: 4px;
  color: ${(props) => {
    switch (props.variant) {
      case 'vegan':
        return '#227f0b';
      default:
        return 'inherit';
    }
  }};
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
`;

export const Image = styled.img`
  width: 1em;
  height: 1em;
  margin-right: 4px;
  vertical-align: -1px;
`;
